var map = {
	"./ls-ehs-losses.svg": "./src/assets/img/loss-analysis-icons/ls-ehs-losses.svg",
	"./ls-finance-data.svg": "./src/assets/img/loss-analysis-icons/ls-finance-data.svg",
	"./ls-it-losses.svg": "./src/assets/img/loss-analysis-icons/ls-it-losses.svg",
	"./ls-line-efficiency-losses.svg": "./src/assets/img/loss-analysis-icons/ls-line-efficiency-losses.svg",
	"./ls-maintenance-losses.svg": "./src/assets/img/loss-analysis-icons/ls-maintenance-losses.svg",
	"./ls-operator-effort-losses.svg": "./src/assets/img/loss-analysis-icons/ls-operator-effort-losses.svg",
	"./ls-quality-losses.svg": "./src/assets/img/loss-analysis-icons/ls-quality-losses.svg",
	"./ls-warehouse-losses.svg": "./src/assets/img/loss-analysis-icons/ls-warehouse-losses.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/loss-analysis-icons sync recursive ^\\.\\/.*$";